import { createSelector } from 'reselect';
import { filter, get } from 'lodash/fp';
import { flow } from 'fp-ts/function';
import { createAction, createReducer } from '@mews/framework';
import { getStringProp, keyById } from '@mews/fp';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { SERVICE_FETCH_SUCCEEDED } from './actionTypes';

export const NAME = 'businessSegments';

const BUSINESS_SEGMENTS_LOADED = prefix('BUSINESS_SEGMENTS_LOADED');
export const setBusinessSegments = (businessSegments: $TSFixMe) =>
    createAction(BUSINESS_SEGMENTS_LOADED, { entities: businessSegments });

export const businessSegmentsReducer = createReducer(
    {},
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [SERVICE_FETCH_SUCCEEDED]: (state, { businessSegments }: $TSFixMe) => ({
            ...state,
            ...keyById(businessSegments),
        }),
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [BUSINESS_SEGMENTS_LOADED]: (state, { entities }: $TSFixMe) => ({
            ...state,
            ...keyById(entities),
        }),
    }
);

export const getBusinessSegments = createSelector(moduleSelector, (module) => module[NAME] || {});
const getBusinessSegmentById = createSelector(getStringProp('businessSegmentId'), getBusinessSegments, get);
export const getBusinessSegmentName = flow(getBusinessSegmentById, get('name'));

export const getServiceBusinessSegments = createSelector(
    getBusinessSegments,
    getStringProp('serviceId'),
    (segments, serviceId) => filter({ serviceId }, segments)
);
